function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isNil } from 'ramda';
import { i18n, PermissionService, SessionSelectors, MetadataActions, MetadataConstants, MetadataSelectors } from 'invision-core';
import { stateGo } from 'redux-ui-router';
import LocaleKeys from '../../../../../locales/keys';
import { ORDERING_ACCESS } from '../../../../../security.attributes';
import { goToCheckoutForRestoreSubscription } from '../../../../../reducers/actions/products.order.actions';
import { CurrentCustomerIdSelector, RouteParams, RouteState } from '../../../../../reducers/selectors/customer.selectors';
import { BillingCycleSelector, BrandableCurrencyNameSelector, BriefSubscriptionsSelector, CurrencySelector, CurrentPricingPlanSelector, CurrentSubscriptionPricingPlanSelector, CurrentSubscriptionProductSelector, CurrentSubscriptionSelector, IsASubscriptionExtensionActive, IsFetchingSubscriptionDetailsSelector, OriginalPricingPlanSelector, RecordCountSelector, subscriptionActionListSelector, SubscriberHasAnyAlignedSubscriptionsSelector, UserCanRemoveExtensionSelector, UserCanRemoveSubscriptionSelector, UserCanRenewSelector, UserCanRestoreSubscriptionSelector, UserCanUpdateSubscriptionSelector } from '../../../../../reducers/selectors/customer.subscriptions.selectors';
import { SubscriptionItemsExtensionSelectors } from '../../../../../reducers/selectors/customer.subscriptions.products.selectors';
import { retrieveSubscription, searchSubscriptions, viewSubscriptionTransactions } from '../../../../../reducers/actions/customer.subscriptions.actions';
import { SUBSCRIPTION_DETAILS_ROUTE } from '../../../subscriptions/subscriptions.config';
var SUBSCRIPTIONS_SEARCH_CRITERIA = {
  IncludePaymentInstrumentInfo: true,
  IncludeRemoved: false,
  PageSize: 5,
  SortDirection: 2
};
var SUBSCRIPTIONS_VIEW_TO = 'index.customercare.customer.subscriptions';
var SUBSCRIPTION_REMOVE_TO = 'index.customercare.customer.subscriptions.detail.remove';
export var SubscriptionsWidgetController = /*#__PURE__*/function () {
  function SubscriptionsWidgetController($ngRedux, uiNotificationService, $timeout) {
    var _this = this;
    _classCallCheck(this, SubscriptionsWidgetController);
    Object.assign(this, {
      $timeout: $timeout,
      $ngRedux: $ngRedux,
      localeKeys: LocaleKeys,
      uiNotificationService: uiNotificationService
    });
    this.manualRenewal = i18n.translate(this.localeKeys.SUBSCRIPTIONS.MANUAL_RENEWAL);
    this.autoRenewal = i18n.translate(this.localeKeys.SUBSCRIPTIONS.AUTOMATIC_RENEWAL);
    this._actionItemDictionary = {
      View: [{
        title: i18n.translate(this.localeKeys.VIEW_DETAILS),
        selected: false,
        shouldShow: function shouldShow() {
          return true;
        }
      }, {
        title: i18n.translate(this.localeKeys.CUSTOMER_DASHBOARD.TRANSACTIONS),
        selected: false,
        shouldShow: function shouldShow() {
          return true;
        }
      }],
      Restore: [{
        title: i18n.translate(this.localeKeys.SUBSCRIPTIONS.RESTORE_SUBSCRIPTION),
        selected: false,
        shouldShow: function shouldShow() {
          return _this.state.userCanRestoreSubscription;
        }
      }],
      Modify: [{
        title: i18n.translate(this.localeKeys.SUBSCRIPTIONS.MODIFY_RENEWAL),
        selected: false,
        shouldShow: function shouldShow() {
          return _this.state.userCanRenew;
        }
      }, {
        title: i18n.translate(this.localeKeys.SUBSCRIPTIONS.MODIFY),
        selected: false,
        shouldShow: function shouldShow() {
          return _this.state.userCanUpdate && !_this.currentSubscriptionIsAligned();
        }
      }],
      Remove: [{
        title: i18n.translate(this.localeKeys.SUBSCRIPTIONS.REMOVE_SUBSCRIPTION.REMOVE),
        selected: false,
        shouldShow: function shouldShow() {
          return _this.state.userCanRemove && !_this.currentSubscriptionIsAligned();
        }
      }, {
        title: i18n.translate(this.localeKeys.SUBSCRIPTIONS.REMOVE_SUBSCRIPTION.REMOVE_ALL),
        selected: false,
        shouldShow: function shouldShow() {
          return _this.state.userCanRemove && _this.currentSubscriptionIsAligned();
        }
      },
      /*
          TO-DO
          -The shouldShow logic is also dependent on the existence of an extension which will be
          added in later PR
      */
      {
        title: i18n.translate(this.localeKeys.SUBSCRIPTIONS.REMOVE_EXTENSION.REMOVE_EXTENSION),
        selected: false,
        shouldShow: function shouldShow() {
          return _this.state.userCanRemoveExtension;
        }
      }]
    };
    this.showAllSubscriptionItems = false;
    this.shouldShowExpandCollapseLink = false;
    this.currentSubscriptionList = [];
  }
  return _createClass(SubscriptionsWidgetController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var controllerActions = {
        goToCheckoutForRestoreSubscription: goToCheckoutForRestoreSubscription,
        fetchCodeTypes: MetadataActions.codes.fetchCodeTypes,
        retrieveSubscription: retrieveSubscription,
        searchSubscriptions: searchSubscriptions,
        stateGo: stateGo,
        viewSubscriptionTransactions: viewSubscriptionTransactions
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          actionList: subscriptionActionListSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentPricingPlan: CurrentPricingPlanSelector(store),
          isFetchingSubscriptionDetails: IsFetchingSubscriptionDetailsSelector(store),
          renewalPricingPlan: OriginalPricingPlanSelector(store),
          routeParams: RouteParams(store),
          routeState: RouteState(store),
          selectedSubscription: CurrentSubscriptionSelector(store),
          selectedSubscriptionBillingCycleName: BillingCycleSelector(store),
          selectedSubscriptionBrandableCurrencyName: BrandableCurrencyNameSelector(store),
          selectedSubscriptionCurrency: CurrencySelector(store),
          selectedSubscriptionPricingPlan: CurrentSubscriptionPricingPlanSelector(store),
          selectedSubscriptionProduct: CurrentSubscriptionProductSelector(store),
          showAsAligned: SubscriberHasAnyAlignedSubscriptionsSelector(store),
          showRenewalPricingPlan: IsASubscriptionExtensionActive(store),
          subscriptions: BriefSubscriptionsSelector(store),
          subscriptionsCount: RecordCountSelector(store),
          subscriptionItemsExtensions: SubscriptionItemsExtensionSelectors(store),
          subscriptionStateIndicatorsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.SubscriptionStateIndicator, store),
          userCanRemove: UserCanRemoveSubscriptionSelector(store),
          userCanRemoveExtension: UserCanRemoveExtensionSelector(store),
          userCanRenew: UserCanRenewSelector(store),
          userCanRestoreSubscription: UserCanRestoreSubscriptionSelector(store),
          userCanUpdate: UserCanUpdateSubscriptionSelector(store),
          userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      if (!this.state.subscriptionStateIndicatorsLoaded) {
        this.actions.fetchCodeTypes(MetadataConstants.codes.SubscriptionStateIndicator);
      }
      this.toggleModifyRenewalModal = false;
      this.modifyRenewalModal = {
        onRegisterApi: function onRegisterApi(evt) {
          _this2.modifyRenewalModal = evt.api;
        }
      };
      if (this.state.currentCustomerId && this.hasWidgetAccess()) {
        this.searchSubscriptions();
      }
      this.toggleModifyModal = false;
      this.removeExtensionModalConfig = {
        onRegisterApi: function onRegisterApi(evt) {
          _this2.removeExtensionModalApi = evt.api;
        }
      };
      this.onSubscriptionExtensionRemoveListComplete = function (extensionId) {
        _this2.removeExtensionModalApi.close();
        _this2.actions.stateGo('index.customercare.customer.subscriptions.detail.extension', {
          subscriptionId: _this2.state.selectedSubscription.Id,
          extensionId: extensionId,
          currency: _this2.state.selectedSubscriptionCurrency
        });
      };
      this.closeSubscriptionExtensionRemoveListPopup = function () {
        _this2.removeExtensionModalApi.close();
      };
    }
  }, {
    key: "openRenewalModal",
    value: function openRenewalModal() {
      this.toggleModifyRenewalModal = true;
      this.$timeout(this.modifyRenewalModal.open);
    }
  }, {
    key: "closeRenewalModal",
    value: function closeRenewalModal() {
      this.modifyRenewalModal.close();
      this.toggleModifyRenewalModal = false;
    }
  }, {
    key: "onRenewModalSuccess",
    value: function onRenewModalSuccess() {
      this.closeRenewalModal();
      this.searchSubscriptions(this.state.selectedSubscription.Id);
    }
  }, {
    key: "searchSubscriptions",
    value: function searchSubscriptions(activeSubscriptionId) {
      var _this3 = this;
      this.actions.searchSubscriptions(this.state.currentCustomerId, SUBSCRIPTIONS_SEARCH_CRITERIA).then(function () {
        _this3.viewAllText = i18n.translate(_this3.localeKeys.CUSTOMER_DASHBOARD.VIEW_ALL_SUBSCRIPTIONS, {
          count: _this3.state.subscriptionsCount
        });
        if (_this3.state.subscriptions.length) {
          _this3.retrieveSubscription(activeSubscriptionId || _this3.state.subscriptions[0].id);
        }
      });
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.customerId && !isNil(this.state.currentCustomerId) && !changesObj.customerId.isFirstChange() && this.actions && this.hasWidgetAccess()) {
        this.actions.searchSubscriptions(this.state.currentCustomerId, SUBSCRIPTIONS_SEARCH_CRITERIA);
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "actionsList",
    get: function get() {
      return this._actionsList;
    }
  }, {
    key: "onOptionSelect",
    value: function onOptionSelect(option) {
      switch (option.item.title) {
        case i18n.translate(this.localeKeys.VIEW_DETAILS):
          this.viewSubscriptionDetails();
          break;
        case i18n.translate(this.localeKeys.CUSTOMER_DASHBOARD.TRANSACTIONS):
          this.viewSubscriptionTransactions();
          break;
        case i18n.translate(this.localeKeys.SUBSCRIPTIONS.MODIFY_RENEWAL):
          this.openRenewalModal();
          break;
        case i18n.translate(this.localeKeys.SUBSCRIPTIONS.MODIFY):
          this.openModifyModal();
          break;
        case i18n.translate(this.localeKeys.SUBSCRIPTIONS.RESTORE_SUBSCRIPTION):
          this.restoreSubscription();
          break;
        case i18n.translate(this.localeKeys.SUBSCRIPTIONS.REMOVE_SUBSCRIPTION.REMOVE):
          this.viewRemoveSubscription();
          break;
        case i18n.translate(this.localeKeys.SUBSCRIPTIONS.REMOVE_SUBSCRIPTION.REMOVE_ALL):
          this.viewRemoveSubscription();
          break;
        case i18n.translate(this.localeKeys.SUBSCRIPTIONS.REMOVE_EXTENSION.REMOVE_EXTENSION):
          this.removeExtensionModalApi.open();
          break;
        default:
          break;
      }
    }
  }, {
    key: "currentSubscriptionIsAligned",
    value: function currentSubscriptionIsAligned() {
      return this.state.selectedSubscription && this.state.selectedSubscription.Items && this.state.selectedSubscription.Items.length > 1;
    }
  }, {
    key: "setCurrentSubscriptionItemsList",
    value: function setCurrentSubscriptionItemsList() {
      if (this.state.selectedSubscription && this.state.selectedSubscription.Items) {
        var firstHasBundleChildren = this.state.selectedSubscription.Items[0].Children && this.state.selectedSubscription.Items[0].Children.length;
        var numberOfCollapsedItemsToShow = firstHasBundleChildren ? 1 : 3;
        this.shouldShowExpandCollapseLink = this.state.selectedSubscription.Items.length > numberOfCollapsedItemsToShow;
        if (!this.showAllSubscriptionItems && this.shouldShowExpandCollapseLink) {
          this.currentSubscriptionList = this.state.selectedSubscription.Items.slice(0, numberOfCollapsedItemsToShow);
        } else {
          this.currentSubscriptionList = this.state.selectedSubscription.Items;
        }
      }
    }
  }, {
    key: "toggleShowMoreSubscriptionList",
    value: function toggleShowMoreSubscriptionList() {
      this.showAllSubscriptionItems = !this.showAllSubscriptionItems;
      this.setCurrentSubscriptionItemsList();
    }
  }, {
    key: "hasWidgetAccess",
    value: function hasWidgetAccess() {
      return PermissionService.hasAccess(this.state.userSecurityAttributes, ORDERING_ACCESS);
    }
  }, {
    key: "onSelectSubscription",
    value: function onSelectSubscription(subscription) {
      this.retrieveSubscription(subscription.id);
    }
  }, {
    key: "retrieveSubscription",
    value: function retrieveSubscription(subscriptionId) {
      var _this4 = this;
      this.actions.retrieveSubscription(this.state.currentCustomerId, {
        Id: subscriptionId,
        IncludeChangeOptions: true
      }).then(function () {
        _this4.setActionItemsList();
        _this4.setCurrentSubscriptionItemsList();
      });
    }
  }, {
    key: "setActionItemsList",
    value: function setActionItemsList() {
      var _this5 = this;
      this.state.actionList.forEach(function (action) {
        action.filteredActions = _this5._actionItemDictionary[action.category].filter(function (item) {
          return item.shouldShow();
        });
      });
    }
  }, {
    key: "viewRemoveExtension",
    value: function viewRemoveExtension() {
      /*
       TO-DO: When remove subscription-extension API is ready.
      */
    }
  }, {
    key: "restoreSubscription",
    value: function restoreSubscription() {
      var _this6 = this;
      this.actions.stateGo(SUBSCRIPTION_DETAILS_ROUTE, {
        subscriptionId: this.state.selectedSubscription.Id
      }).then(function () {
        _this6.actions.goToCheckoutForRestoreSubscription(_this6.state.selectedSubscription.Id);
      });
    }
  }, {
    key: "viewRemoveSubscription",
    value: function viewRemoveSubscription() {
      this.actions.stateGo(SUBSCRIPTION_REMOVE_TO, {
        subscriptionId: this.state.selectedSubscription.Id
      });
    }
  }, {
    key: "viewSubscriptionDetails",
    value: function viewSubscriptionDetails() {
      this.actions.stateGo(SUBSCRIPTION_DETAILS_ROUTE, {
        subscriptionId: this.state.selectedSubscription.Id
      });
    }
  }, {
    key: "viewSubscriptionList",
    value: function viewSubscriptionList() {
      this.actions.stateGo(SUBSCRIPTIONS_VIEW_TO);
    }
  }, {
    key: "viewSubscriptionTransactions",
    value: function viewSubscriptionTransactions() {
      this.actions.viewSubscriptionTransactions({
        name: this.state.routeState.name,
        params: this.state.routeParams
      }, this.state.selectedSubscription);
    }
  }, {
    key: "openModifyModal",
    value: function openModifyModal() {
      this.toggleModifyModal = true;
    }
  }, {
    key: "closeModifyModal",
    value: function closeModifyModal() {
      this.toggleModifyModal = false;
    }
  }]);
}();
export default {
  template: require('./subscriptions.html'),
  controller: SubscriptionsWidgetController,
  controllerAs: 'Subscriptions'
};